import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LMGainsightInitializerService } from '@services/lm-gainsight-initializer.service';

@NgModule({
  imports: [ CommonModule ],
  declarations: [],
  providers: [
    provideAppInitializer(() => {
      const service = inject(LMGainsightInitializerService);
      return service.initialize();
    })
  ]
})
export class LMGainsightInitializerModule {}
